var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('mobile-money-accounts-details',{attrs:{"mobilemoney":_vm.account}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }